import { machineEventsMainMenuAvailable, timelineAvailable } from '@config/navigationRestrictions';
import { injectConditionalObject } from '@helpers';
import { ContextLink, MachinesScreen, MetricTypeLink, NowSubScreen, NowSubScreenTitles, TimePeriod } from '@v2/pages/machines/common/enums';

export const withFeatureFlags = [
  {
    title: MachinesScreen.SCHEDULED,
    featureFlagName: 'machine-scheduled',
  },
  { title: MachinesScreen.MAINTENANCE, featureFlagName: 'machine-maintenance' },
];

const context = {
  [ContextLink.LIVE]: MachinesScreen.LIVE,
  [ContextLink.PERFORMANCE]: MachinesScreen.PERFORMANCE,
  [ContextLink.HISTORY]: MachinesScreen.HISTORY,
  ...injectConditionalObject(timelineAvailable, { [ContextLink.TIMELINE]: MachinesScreen.TIMELINE }),
  ...injectConditionalObject(machineEventsMainMenuAvailable, { [ContextLink.EVENTS]: MachinesScreen.EVENTS }),
  [ContextLink.SCHEDULED]: MachinesScreen.SCHEDULED,
  [ContextLink.MAINTENANCE]: MachinesScreen.MAINTENANCE,
};

export const metricTypes = {
  [MetricTypeLink.UTILIZATION]: MachinesScreen.UTILIZATION,
  [MetricTypeLink.ACTIVE]: MachinesScreen.ACTIVE,
  [MetricTypeLink.PRODUCTIVE]: MachinesScreen.PRODUCTIVE,
  [MetricTypeLink.PAID]: MachinesScreen.PAID,
};

export const contextHeaderMetricTypes = {
  [MetricTypeLink.ACTIVE]: MachinesScreen.ACTIVE,
  [MetricTypeLink.PRODUCTIVE]: MachinesScreen.PRODUCTIVE,
  [MetricTypeLink.PAID]: MachinesScreen.PAID,
};

export const timePeriod = {
  [TimePeriod.DAY]: 'Day',
  [TimePeriod.WEEK]: 'Week',
  [TimePeriod.MONTH]: 'Month',
  [TimePeriod.EIGHT_WEEKS]: '8 Weeks',
  [TimePeriod.YEAR]: 'Year',
};

export const navigationLevels = {
  context,
  metricTypes,
  contextHeaderMetricTypes,
  timePeriod,
};

export const GATED_CONTENT_STATE_SCREENS: MachinesScreen[] = [MachinesScreen.LIVE];

export const nowSubScreenToTitleMap = {
  [NowSubScreen.PART]: NowSubScreenTitles.PART,
  [NowSubScreen.JOB]: NowSubScreenTitles.JOB,
  [NowSubScreen.BATCH]: NowSubScreenTitles.BATCH,
  [NowSubScreen.NC_FILE]: NowSubScreenTitles.NC_FILE,
  [NowSubScreen.TOOLS]: NowSubScreenTitles.TOOLS,
};
